import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ImageGalleryComponent } from '@libs/common/components';
import { ProductModel } from '@libs/shop/models';
import { ProductLabelsComponent } from '../../catalog';
import { ProductDetailDataComponent } from '../product-detail-data';

@Component({
  selector: 'ui-product-detail-header',
  templateUrl: './product-detail-header.component.html',
  styleUrls: ['./product-detail-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageGalleryComponent,
    MatCardModule,
    ProductDetailDataComponent,
    ProductLabelsComponent,
  ],
})
export class ProductDetailHeaderComponent{
  public readonly detailsDataScrollElement: InputSignal<HTMLElement | undefined> = input();
  public readonly showProductLabels: InputSignal<boolean> = input(true);
  public readonly showProductInformationOnly: InputSignal<boolean> = input(false);
  public readonly product: InputSignal<ProductModel> = input.required<ProductModel>();
}
